import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { App } from './App';
import { QueryClient, QueryClientProvider } from 'react-query';
import theme from './theme/theme.config';
import { ChakraProvider } from '@chakra-ui/react';
import { AssessmentTokenProvider } from './context/AssessmentTokenContext';
import { SelectedCourseProvider } from './context/SelectedCourseContext';
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container);

const queryClient = new QueryClient();

root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<ChakraProvider theme={theme}>
				<AssessmentTokenProvider>
					<SelectedCourseProvider>
						<App />
					</SelectedCourseProvider>
				</AssessmentTokenProvider>
			</ChakraProvider>
		</QueryClientProvider>
	</React.StrictMode>,
);
